import React from "react"
import {
  PuxButton,
  PuxButtons,
  PuxSpinner,
  PuxToolbar,
  PuxTypography,
  useBreakpoint,
} from "@phonero/pux-react"
import cx from "classnames"
import { AnyFunc } from "simplytyped"
import css from "./StepButtons.module.scss"
import {VippsButton} from "./VippsButton"

export const StepButtons = ({
  onNext,
  onPrev,
  onDone,
  onConfirm,
  onCancel,
  onPayWithVipps,
  loading,
  confirmDisabled,
  disabledDone,
  nextDisabled,
  previousDisabled,
  cancelDisabled,
  nextText = "Fortsett",
  prevText = "Tilbake",
  confirmText = "Bekreft",
  doneText = "Lukk",
  cancelText = "Avbryt",
  payWithVippsText = "Betal med vipps"
}: {
  onNext?: false | null | AnyFunc
  onPrev?: false | null | AnyFunc
  onDone?: false | null | AnyFunc
  onConfirm?: false | null | AnyFunc
  onCancel?: false | null | AnyFunc
  onPayWithVipps?: false | null | AnyFunc
  loading?: boolean
  disabledDone?: boolean
  nextDisabled?: boolean
  previousDisabled?: boolean
  confirmDisabled?: boolean
  cancelDisabled?: boolean
  nextText?: React.ReactNode
  prevText?: React.ReactNode
  confirmText?: React.ReactNode
  doneText?: React.ReactNode
  cancelText?: React.ReactNode
  payWithVippsText?: string
}) => {
  const buttonProps: Parameters<typeof PuxButton>[0] = {
    fill: "solid",
    style: { width: "25rem" },
  }
  const done = !!onDone
  const hasNext = !!onNext
  const hasPrev = !!onPrev
  const hasConfirm = !!onConfirm
  const hasCancel = !!onCancel
  const hasPayWithVipps = !!onPayWithVipps

  const sm = useBreakpoint("sm", { useMax: true, useMin: false })

  return (
    <PuxToolbar>
      <PuxButtons className={cx(css.buttons, sm && css.buttonsWide)}>
        {done ? (
          <PuxButton
            disabled={disabledDone}
            {...buttonProps}
            color="medium"
            {...(!!onDone && { onClick: onDone })}
          >
            {doneText}
          </PuxButton>
        ) : (
          <>
            {hasCancel && (
              <PuxButton
                {...buttonProps}
                disabled={cancelDisabled || loading}
                color="light"
                {...(onCancel && { onClick: onCancel })}
                {...(sm && { style: { "--pux-color-light": "#edeef0" } })}
              >
                <div className={cx(!sm && css.buttonOnTheLeft)}>
                  {cancelText}
                </div>
              </PuxButton>
            )}
            {hasPrev && (
              <PuxButton
                {...buttonProps}
                disabled={previousDisabled || loading}
                color="light"
                {...(onPrev && { onClick: onPrev })}
              >
                <div className={cx(!sm && css.buttonOnTheLeft)}>{prevText}</div>
              </PuxButton>
            )}
            {hasNext && (
              <PuxButton
                {...buttonProps}
                disabled={nextDisabled || loading}
                {...(onNext && { onClick: onNext })}
              >
                {loading && (
                  <PuxSpinner style={{ position: "absolute", left: 8 }} />
                )}
                {nextText}
              </PuxButton>
            )}
            {hasConfirm && (
              <PuxButton
                {...buttonProps}
                disabled={confirmDisabled || loading}
                {...(onConfirm && { onClick: onConfirm })}
              >
                {loading && (
                  <PuxSpinner style={{ position: "absolute", left: 8 }} />
                )}
                {confirmText}
              </PuxButton>
            )}
            {hasPayWithVipps && (
              <>
                {!loading && (
                  <div style={{ textAlign: "center" }}>
                    <PuxTypography variant="info-small">
                      Ved å fortsette med Vipps, bekrefter jeg kjøpet og godtar
                      Phonero sine{" "}
                      <a href="https://phonero.no" target="_blank" rel="noreferrer" className="link underline">
                        vilkår
                      </a>
                      .
                    </PuxTypography>
                    <VippsButton
                      {...buttonProps}
                      disabled={confirmDisabled || loading}
                      {...(onPayWithVipps && { onClick: () => onPayWithVipps() })}
                      buttonText={payWithVippsText}
                    />
                  </div>
                )}
                {loading && (
                  <PuxSpinner style={{ position: "absolute", left: 8 }} />
                )}
              </>
            )}
          </>
        )}
      </PuxButtons>
    </PuxToolbar>
  )
}
